import { useEffect, useState  } from "react";
import { Card, Accordion } from "react-bootstrap";
import Select from "react-dropdown-select";
import CustomDropdown from "../CustomDropdown";
import CustomControl from "../CustomControl";
import OverlayContainer from "../OverlayContainer";
import SelectedMotorizedStep9APleated from "../SelectedMotorizedStep9APleated";

export default function Step9AcomponentPleated({
  step8,
  depSet,
  accordionActiveKey,
  ContextAwareToggle,
  t,
  requiredStep,
  stepSelectedLabel,
  step9ADrapery,
  setStep8A1,
  setStep8A2,
  setStep8A3,
  setSelectedDrapery,
  setStep9ADrapery,
  extendedTitle,
  setExtendedTitle,
  setDeps,
  setCart,
  selectChanged,
  inputs,
  step3,
  step31,
  selectUncheck,
  modalHandleShow,
  rodsList2,
  rodsColorList2,
  rodsLoad,
  step8A1,
  step8A3,
  GetPrice,
  isTabletOrMobile,
  modelAccessories,
  pageLanguage,
  pageLoad,
  draperiesSelect,
  selectedDrapery,
  rodsLoad2,
  NextStep,
  step6CHead,
  tracksList3,
  rodsColorList6,
  stepTrackCollections9A,
  step81,
  step8D1,
  trackType8B,
  motorErr1,
  step8B6,
  setStep8B6,
  setMotorErr1,
  setSelectedMotorPositionA,
  setSelectedRemoteNameA,
  setSelectedMotorChannelsA,
  motorChannels,
  setRemoteNameA,
  selectedMotorPositionA,
  selectedRemoteNameA,
  selectedMotorChannelsA,
  remoteNames,
  showRemoteName,
  Capitalize,
  remoteNameA,
  MotorPosition,
  setShowRemoteName,
  setCartLoading,
  rodsColorList5,
  stepControl9A,
  setStepControl9A,
  step9APosition,
  setStep9APosition,
  step5,
  setNameBattonEnDraperyTrack,
  setNameBattonEnDraperyTrack9a,
  widthCart,
  sheersSelect3,
  sheersSelect2,
  sheersSelect,
  setStep6CHead,
  setStep6BHead,
  setStep6DHead,
  setStep6CHead9,
  setSelectedSheer,
  step8RodCheck,
  step8DTrack,
  setStepTCollections9A,
  stepTCollections9A,
  setStepTrackCollections9A,
  windowWidthPanelType
}) {
  const [isDisabled, setIsDisabled] = useState(false);
  const [isDisabledRod, setIsDisabledRod] = useState(false);
  const [sheerDraperyOptions, setSheerDraperyOptions] = useState(sheersSelect[pageLanguage]);
  const [isShowColorTrack , setIsShowColorTrack] = useState(false);
  const [isShowColorRod , setIsShowColorRod] = useState(false);
  useEffect(() => {
  if(parseInt(windowWidthPanelType) < 160 && step3 === "false"){
    setStep6CHead("Rod"); 
    setStep6BHead("Rod"); 
    setStep6DHead("Rod"); 
    setStep6CHead9("Rod");
  }

    let newIsDisabled;
    let newIsDisabledRod;


    if (step31 === "false" && parseInt(windowWidthPanelType) < 160) {
      newIsDisabled = false;
    } else if (step6CHead === "Track") {
      newIsDisabled = false;
    } else if (step6CHead === "Rod" && parseInt(windowWidthPanelType) > 160) {
      newIsDisabled = true;
    } else if (step3 === "false" && parseInt(windowWidthPanelType) < 160) {
      newIsDisabled = false;
    } else if (step3 === "true" && parseInt(windowWidthPanelType) < 160 && step31 === "true") {
      newIsDisabled = true;
    }

    if (step6CHead === "Rod") {
      newIsDisabledRod = false;
    } else if (step6CHead === "Track" && parseInt(windowWidthPanelType) > 160 ) {
      newIsDisabledRod = true;
    } else if (step6CHead === "Track" && parseInt(windowWidthPanelType) < 160 && step31 === "Track" && step3 === "true"  ) {
      newIsDisabledRod = true;
    } else {
      newIsDisabledRod = false;
    }

   

  if (parseInt(windowWidthPanelType) <= 160 && step31 !== "true" && step3 !== "true") {
    setSheerDraperyOptions(sheersSelect3[pageLanguage]);
  } else if (parseInt(windowWidthPanelType) <= 160 && step31 === "true" && step3 === "true") {
    setSheerDraperyOptions(sheersSelect[pageLanguage]);
  }  else if (parseInt(windowWidthPanelType) <= 160 && step31 === "false" && step3 === "true") {
    setSheerDraperyOptions(sheersSelect3[pageLanguage]);
  } else if (step6CHead === "Rod") {
    setSheerDraperyOptions(sheersSelect[pageLanguage]);
  } else {
    setSheerDraperyOptions(sheersSelect2[pageLanguage]);
  }

    setIsDisabled(newIsDisabled);
    setIsDisabledRod(newIsDisabledRod);
  }, [step31, windowWidthPanelType, step6CHead, step3 , pageLanguage]);

  useEffect(() => {
    if (step9ADrapery === "Track") {
      setIsShowColorTrack(true);
      setIsShowColorRod(false);
    } else if (step9ADrapery === "Rod" && step8A1) {
      setIsShowColorRod(true);
      setIsShowColorTrack(false);
    }
  }, [step9ADrapery, step8A1]);


  return (
    <Card className={step8 === "I Want To Customize Hardware Per Curtain" ? "" : "noDisplay"}>
      <Card.Header
        className={
          [...depSet].findIndex((el) => el.startsWith("8")) === -1 &&
          !accordionActiveKey.startsWith("8")
            ? "hidden"
            : ""
        }
      >
        <ContextAwareToggle
          eventKey="8A"
          stepNum={ step5 === "Full" && step3 === "false" ? t("8A") : t("9A")}
          stepTitle={t("grommet_step8A")}
          stepRef="8A"
          type="1"
          required={requiredStep["8A"]}
          stepSelected={stepSelectedLabel["8A"] === undefined ? "" : stepSelectedLabel["8A"]}
        />
      </Card.Header>
      <Accordion.Collapse eventKey="8A">
        <Card.Body>
          <div className="card_body2 card_body_radio card_body_radio_new card_body_hardware">
            <div className="boxHardware radio_style">
              <input
                className="radio"
                type="radio"
                text={t("None")}
                value="1"
                name="step9ADrapery"
                ref-num="8A"
                id="8A1"
                checked={step9ADrapery === "None"}
                onChange={(e) => {
                  setRemoteNameA("");
                  setStep8B6("");
                  setStepTCollections9A("");
                  setStepTrackCollections9A("");
                  setDeps("85" , "842,843,84,8B1,844,8A2,8A3,845,846,847,8A");
                  setStep8A1("");
                  setStep8A2("");
                  setStep8A3("");
                  setStep9APosition("");
                  setStep9ADrapery("None");
                  let tempExtended = extendedTitle;
                  tempExtended["8A"] = [t("None")];
                  setExtendedTitle(tempExtended);
                
                  setCart(
                    "DraperyHardware",
                    "None",
                    "BatonOptionA,RailDesignA,RailDesignEnA,RailDesignFaA,RailColorEnA,RailColorFaA,RodColorA,hardwareDrapery"
                  );
                  selectChanged(e);
                }}
                ref={(ref) => (inputs.current["8A1"] = ref)}
              />
              <label htmlFor="8A1">{t("None")}</label>
            </div>
            <div className="boxHardware radio_style">
              <input
                className="radio"
                type="radio"
                text={t("drapery_Rod")}
                value="2"
                name="step9ADrapery"
                ref-num="8A"
                id="8A2"
                checked={step9ADrapery === "Rod"}
                disabled={isDisabledRod}
                onChange={(e) => {
                  setRemoteNameA("");
                  setStep8B6("");
                  setStep9APosition("");
                  setStepTrackCollections9A("");
                  setSelectedDrapery([]);
                  setSelectedSheer([]);
                  setIsShowColorTrack(false);
                  setIsShowColorRod(true);
                  let tempExtended = extendedTitle;
                  setStep8A1("");
                  setStep8A2("");
                  setStep8A3("");
                  // setStep8A4("");
                  if (step3 === "" || (step3 === "true" && step31 === "")) {
                    setStep9ADrapery("");
                    tempExtended["8A"] = [];
                    selectUncheck(e);
                    modalHandleShow("noMeasurements");
                    setCart(
                      "",
                      "",
                      "DraperyHardware,BatonOptionA,RailDesignA,RailDesignEnA,RailDesignFaA,RailColorEnA,RailColorFaA,RodColorA,hardwareDrapery"
                    );
                  } else {
                    setTimeout(() => {
                      setStep9ADrapery("Rod");
                    }, 300);
                    setDeps("84" , "85,842,843,844,8A2,8A3,845,846,847,8A");
                    tempExtended["8A"] = [t("drapery_Rod")];
                    setCart("DraperyHardware", "Rod", "hardwareDrapery");
                    selectChanged(e);
                    
                  }
                  setExtendedTitle(tempExtended);
                }}
                ref={(ref) => (inputs.current["8A2"] = ref)}
              />
              <label htmlFor="8A2">
                {t("drapery_Rod")}
                <br />
                { isDisabledRod &&  (
                  <OverlayContainer
                    classNames="extension_unavailable"
                    placement="bottom"
                    children={
                      <div className="extension_unavailable_title text_underline">
                        {t("Why is this unavailable?")}
                      </div>
                    }
                    component={
                      <div className="extension_unavailable_container">
                        <div className="extension_unavailable_text">
                          {t("track_sheer_hardware_text")}
                        </div>
                      </div>
                    }
                  />
                )}
              </label>
            </div>
            <div className="boxHardware radio_style">
              <input
                className="radio"
                type="radio"
                text={t("sheer_Track")}
                value="2"
                name="step9ADrapery"
                ref-num="8A"
                id="8A3"
                checked={step9ADrapery === "Track"}
                disabled={isDisabled}
                onChange={(e) => {
               
                  setSelectedDrapery([]);
                  setSelectedSheer([]);
                  setIsShowColorTrack(true);
                  setIsShowColorRod(false);
                  let tempExtended = extendedTitle;
                  setStep8A1("");
                  setStep8A2("");
                  setStep8A3("");
                  // setStep8A4("");
                  if (step3 === "" || (step3 === "true" && step31 === "")) {
                    setStep9ADrapery("");
                    tempExtended["8A"] = [];
                    selectUncheck(e);
                    modalHandleShow("noMeasurements");
                  
                    setCart(
                      "",
                      "",
                      "DraperyHardware,BatonOptionA,RailDesignA,RailDesignEnA,RailDesignFaA,RailColorEnA,RailColorFaA,RodColorA,hardwareDrapery"
                    );
                  } else {
                    setTimeout(() => {
                      setStep9ADrapery("Track");
                    }, 300);
                    setDeps("84" , "85,842,843,844,8A2,8A3,845,846,847,8A");
                    tempExtended["8A"] = [t("sheer_Track")];
                    setCart("DraperyHardware", "Track", "hardwareDrapery");
                    selectChanged(e);
                    
                  }
                  setExtendedTitle(tempExtended);
                }}
                ref={(ref) => (inputs.current["8A3"] = ref)}
              />
              <label htmlFor="8A3">
                {t("sheer_Track")}
                <br />
                { isDisabled && (
                  <OverlayContainer
                    classNames="extension_unavailable"
                    placement="bottom"
                    children={
                      <div className="extension_unavailable_title text_underline">
                        {t("Why is this unavailable?")}
                      </div>
                    }
                    component={
                      <div className="extension_unavailable_container">
                        <div className="extension_unavailable_text">
                          {t("rod_sheer_hardware_text")}
                        </div>
                      </div>
                    }
                  />
                )}
              </label>
            </div>
           

            {/* step 10 Questions */}
            <div
              className={
                step9ADrapery !== "None" && step9ADrapery !== ""
                  ? "card_body card_body_radio card_body_Rod"
                  : "noDisplay"
              }
            >
              <div className="box100">
                <p className="step_selection_title">
                  {step9ADrapery === "Rod" ? t("Rod Collection") : t("Track Collection")}
                </p>
              </div>

              {step9ADrapery === "Rod" ? rodsList2 : tracksList3}
            </div>
            <div
              className={
                isShowColorRod === true && step9ADrapery !== "None" && step9ADrapery !== "" && step8A1 !== ""
                  ? "card_body card_body_radio card_body_Rod_color bracket_color 1"
                  : "noDisplay"
              }
            >
              <div className="box100">
                <p className="step_selection_title">{t("step8_rod_finish_title")}</p>
              </div>
              {rodsColorList2}
            </div>

            <div
              className={
                stepTrackCollections9A !== "" && isShowColorTrack === true && (stepTCollections9A === "2201" || stepTCollections9A === "2207")
                  ? "card_body card_body_radio card_body_Rod_color bracket_color 2"
                  : "noDisplay"
              }
            >
              <div className="box100">
                <p className="step_selection_title">{t("step8_rod_finish_title")}</p>
              </div>
              {rodsColorList6}
            </div>

            <div
              className={
                step8 === "I Want To Customize Hardware Per Curtain"  && stepTrackCollections9A !== "" && 
                stepTCollections9A === "2208" && step9ADrapery !== "None" && step9ADrapery !== "Rod"
                  ? "card_body card_body_radio card_body_Rod_color 3"
                  : "noDisplay"
              }
            >
              {stepTCollections9A === "2208" ? (
                <SelectedMotorizedStep9APleated
                  trackType8B={trackType8B}
                  motorErr1={motorErr1}
                  t={t}
                  step8B6={step8B6}
                  selectChanged={selectChanged}
                  setStep8B6={setStep8B6}
                  setMotorErr1={setMotorErr1}
                  setSelectedMotorPositionA={setSelectedMotorPositionA}
                  setSelectedRemoteNameA={setSelectedRemoteNameA}
                  setSelectedMotorChannelsA={setSelectedMotorChannelsA}
                  motorChannels={motorChannels}
                  pageLanguage={pageLanguage}
                  setRemoteNameA={setRemoteNameA}
                  setDeps={setDeps}
                  setCart={setCart}
                  selectUncheck={selectUncheck}
                  inputs={inputs}
                  modalHandleShow={modalHandleShow}
                  selectedMotorPositionA={selectedMotorPositionA}
                  selectedRemoteNameA={selectedRemoteNameA}
                  selectedMotorChannelsA={selectedMotorChannelsA}
                  remoteNames={remoteNames}
                  showRemoteName={showRemoteName}
                  Capitalize={Capitalize}
                  pageLoad={pageLoad}
                  rodsLoad={rodsLoad}
                  rodsLoad2={rodsLoad2}
                  remoteNameA={remoteNameA}
                  MotorPosition={MotorPosition}
                  setShowRemoteName={setShowRemoteName}
                  setCartLoading={setCartLoading}
                  extendedTitle={extendedTitle}
                />
              ) : (
                rodsColorList5
              )}
            </div>

            <div
              className={
                step9ADrapery === "Track" && stepTCollections9A === "2201" && stepTrackCollections9A !== ""
                  ? "card_body card_body_radio card_body_baton"
                  : "noDisplay"
              }
            >
              <div className="box100">
                <p className="step_selection_title">{t("Baton Option")}</p>
              </div>
              <div className="box33 radio_style baton_style">
                <input
                  className="radio"
                  type="radio"
                  text={t("None")}
                  value="1"
                  name="stepControl9A"
                  ref-num="8A"
                  id="8AN13"
                  checked={stepControl9A === "None"}
                  onChange={(e) => {
                    setStepControl9A("None");
                    setDeps("", "8A2,844", 1);
                    setCart("BatonOptionB", "None");
                    selectChanged(e);
                    setNameBattonEnDraperyTrack("None");
                    setNameBattonEnDraperyTrack9a("None");
                    let tempExtended = extendedTitle;
                    tempExtended["8A"][3] = (
                      <li key="3" className="step_title_extended_list_item">
                        <span className="step_title_extended_list_item_title">{t("Baton")}</span>
                        <span className="step_title_extended_list_item_text">{t("None")}</span>
                      </li>
                    );
                    setExtendedTitle(tempExtended);
                  }}
                  ref={(ref) => (inputs.current["8AN13"] = ref)}
                />
                <label htmlFor="8AN13">{t("None")}</label>
              </div>
              <div className="box33 radio_style baton_style">
                <input
                  className="radio"
                  type="radio"
                  text={t("Baton 30cm")}
                  value="2"
                  name="stepControl9A"
                  ref-num="8A"
                  id="8AD21"
                  checked={stepControl9A === "Baton 30cm"}
                  onChange={(e) => {
                    setStepControl9A("Baton 30cm");
                    setDeps("", "8A2,844", 1);
                    setCart("BatonOptionB", "Baton 30cm");
                    selectChanged(e);
                    let tempExtended = extendedTitle;
                    setNameBattonEnDraperyTrack("Baton 30cm");
                    setNameBattonEnDraperyTrack9a("Baton 30cm");
                    tempExtended["8A"][3] = (
                      <li key="3" className="step_title_extended_list_item">
                        <span className="step_title_extended_list_item_title">{t("Baton")}</span>
                        <span className="step_title_extended_list_item_text">
                          {t("Baton 30cm")}
                        </span>
                      </li>
                    );
                    setExtendedTitle(tempExtended);
                  }}
                  ref={(ref) => (inputs.current["8AD21"] = ref)}
                />
                <label htmlFor="8AD21">
                  {t("Baton 30cm")}
                  <br />
                  <p className="surcharge_price">
                    {Object.keys(modelAccessories).length !== 0
                      ? t("Add ")
                      : t("Surcharge Applies")}
                    {modelAccessories["27"]
                      ? modelAccessories["27"]["58"]
                        ? GetPrice(
                            modelAccessories["27"]["58"]["Price"],
                            pageLanguage,
                            t("TOMANS"),
                            isTabletOrMobile
                          )
                        : null
                      : null}
                  </p>
                </label>
              </div>
              <div className="box33 radio_style baton_style">
                <input
                  className="radio"
                  type="radio"
                  text={t("Baton 45cm")}
                  value="3"
                  name="stepControl9A"
                  ref-num="8A"
                  id="8A333"
                  checked={stepControl9A === "Baton 45cm"}
                  onChange={(e) => {
                    setStepControl9A("Baton 45cm");
                    setDeps("", "8A2,844", 1);
                    setCart("BatonOptionB", "Baton 45cm");
                    selectChanged(e);
                    setNameBattonEnDraperyTrack("Baton 45cm");
                    setNameBattonEnDraperyTrack9a("Baton 45cm");
                    let tempExtended = extendedTitle;
                    tempExtended["8A"][3] = (
                      <li key="3" className="step_title_extended_list_item">
                        <span className="step_title_extended_list_item_title">{t("Baton")}</span>
                        <span className="step_title_extended_list_item_text">
                          {t("Baton 45cm")}
                        </span>
                      </li>
                    );
                    setExtendedTitle(tempExtended);
                  }}
                  ref={(ref) => (inputs.current["8A333"] = ref)}
                />
                <label htmlFor="8A333">
                  {t("Baton 45cm")}
                  <br />
                  <p className="surcharge_price">
                    {Object.keys(modelAccessories).length !== 0
                      ? t("Add ")
                      : t("Surcharge Applies")}
                    {modelAccessories["27"]
                      ? modelAccessories["27"]["59"]
                        ? GetPrice(
                            modelAccessories["27"]["59"]["Price"],
                            pageLanguage,
                            t("TOMANS"),
                            isTabletOrMobile
                          )
                        : null
                      : null}
                  </p>
                </label>
              </div>
            
            </div>

            <div
              className={
                step9ADrapery === "Track" && stepTCollections9A === "2207"  && stepTrackCollections9A !== ""
                  ? "card_body card_body_radio card_body_baton"
                  : "noDisplay"
              }
            >
              <div className="box100">
                <p className="step_selection_title">{t("Control Position")}</p>
              </div>
              <div className="box33 radio_style">
                <div className="width_max">
                  <img
                    src={require("../../Images/drapery/grommet/cp_hardware_left.svg").default}
                    className="img-fluid"
                    alt=""
                  />
                  <input
                    className="radio"
                    type="radio"
                    text={t("Left")}
                    value="5"
                    name="step9APosition"
                    ref-num="8A"
                    id="9A314"
                    checked={step9APosition === "Left"}
                    onChange={(e) => {
                      setStep9APosition("Left");
                      setNameBattonEnDraperyTrack9a("Left Control");
                      setDeps("", "8A3,848", 1);
                      setCart("ControlPositionB", "Left Control");
                      selectChanged(e);
                      let tempExtended = extendedTitle;
                      tempExtended["8A"][3] = (
                        <li key="3" className="step_title_extended_list_item">
                          <span className="step_title_extended_list_item_title">
                            {t("Control Position")}
                          </span>
                          <span className="step_title_extended_list_item_text">{t("Left")}</span>
                        </li>
                      );
                      setExtendedTitle(tempExtended);
                    }}
                    ref={(ref) => (inputs.current["9A314"] = ref)}
                  />
                  <label htmlFor="9A314">{t("Left")}</label>
                </div>
              </div>
              <div className="box33 radio_style">
                <div className="width_max">
                  <img
                    src={require("../../Images/drapery/grommet/cp_hardware_right.svg").default}
                    className="img-fluid"
                    alt=""
                  />
                  <input
                    className="radio"
                    type="radio"
                    text={t("Right")}
                    value="6"
                    name="step9APosition"
                    ref-num="8A"
                    id="9A316"
                    checked={step9APosition === "Right"}
                    onChange={(e) => {
                      setStep9APosition("Right");
                      setNameBattonEnDraperyTrack9a("Right Control");
                      setDeps("", "8A3,848", 1);
                      setCart("ControlPositionB", "Right Control");
                      selectChanged(e);
                      let tempExtended = extendedTitle;
                      tempExtended["8A"][3] = (
                        <li key="3" className="step_title_extended_list_item">
                          <span className="step_title_extended_list_item_title">
                            {t("Control Position")}
                          </span>
                          <span className="step_title_extended_list_item_text">{t("Right")}</span>
                        </li>
                      );
                      setExtendedTitle(tempExtended);
                    }}
                    ref={(ref) => (inputs.current["9A316"] = ref)}
                  />
                  <label htmlFor="9A316">{t("Right")}</label>
                </div>
              </div>
            </div>

            <div
              className={
                step9ADrapery !== "None" && step9ADrapery !== "" && step8A1 !== ""
                  ? "card_body card_body_radio card_body_baton"
                  : "noDisplay"
              }
            >
              <div className="box100">
                <p className="step_selection_title">{t("Baton Option")}</p>
              </div>
              <div className="box33 radio_style baton_style">
                <input
                  className="radio"
                  type="radio"
                  text={t("None")}
                  value="1"
                  name="step8A3"
                  ref-num="8A"
                  id="8A31"
                  checked={step8A3 === "None"}
                  onChange={(e) => {
                    setStep8A3("None");
                    setDeps("", "8A2,8B2,843", 1);
                    setCart("BatonOptionA", "None");
                    selectChanged(e);
                    let tempExtended = extendedTitle;
                    tempExtended["8A"][3] = (
                      <li key="3" className="step_title_extended_list_item">
                        <span className="step_title_extended_list_item_title">{t("Baton")}</span>
                        <span className="step_title_extended_list_item_text">{t("None")}</span>
                      </li>
                    );
                    setExtendedTitle(tempExtended);
                  }}
                  ref={(ref) => (inputs.current["8A31"] = ref)}
                />
                <label htmlFor="8A31">{t("None")}</label>
              </div>
              <div className="box33 radio_style baton_style">
                <input
                  className="radio"
                  type="radio"
                  text={t("Baton 30cm")}
                  value="2"
                  name="step8A3"
                  ref-num="8A"
                  id="8A32"
                  checked={step8A3 === "Baton 30cm"}
                  onChange={(e) => {
                    setStep8A3("Baton 30cm");
                    setDeps("", "8A2,843", 1);
                    setCart("BatonOptionA", "Baton 30cm");
                    selectChanged(e);
                    let tempExtended = extendedTitle;
                    tempExtended["8A"][3] = (
                      <li key="3" className="step_title_extended_list_item">
                        <span className="step_title_extended_list_item_title">{t("Baton")}</span>
                        <span className="step_title_extended_list_item_text">
                          {t("Baton 30cm")}
                        </span>
                      </li>
                    );
                    setExtendedTitle(tempExtended);
                  }}
                  ref={(ref) => (inputs.current["8A32"] = ref)}
                />
                <label htmlFor="8A32">
                  {t("Baton 30cm")}
                  <br />
                  <p className="surcharge_price">
                    {Object.keys(modelAccessories).length !== 0
                      ? t("Add ")
                      : t("Surcharge Applies")}
                    {modelAccessories["27"]
                      ? modelAccessories["27"]["58"]
                        ? GetPrice(
                            modelAccessories["27"]["58"]["Price"],
                            pageLanguage,
                            t("TOMANS"),
                            isTabletOrMobile
                          )
                        : null
                      : null}
                  </p>
                </label>
              </div>
              <div className="box33 radio_style baton_style">
                <input
                  className="radio"
                  type="radio"
                  text={t("Baton 45cm")}
                  value="3"
                  name="step8A3"
                  ref-num="8A"
                  id="8A33"
                  checked={step8A3 === "Baton 45cm"}
                  onChange={(e) => {
                    setStep8A3("Baton 45cm");
                    setDeps("", "8A2,843", 1);
                    setCart("BatonOptionA", "Baton 45cm");
                    selectChanged(e);
                    let tempExtended = extendedTitle;
                    tempExtended["8A"][3] = (
                      <li key="3" className="step_title_extended_list_item">
                        <span className="step_title_extended_list_item_title">{t("Baton")}</span>
                        <span className="step_title_extended_list_item_text">
                          {t("Baton 45cm")}
                        </span>
                      </li>
                    );
                    setExtendedTitle(tempExtended);
                  }}
                  ref={(ref) => (inputs.current["8A33"] = ref)}
                />
                <label htmlFor="8A33">
                  {t("Baton 45cm")}
                  <br />
                  <p className="surcharge_price">
                    {Object.keys(modelAccessories).length !== 0
                      ? t("Add ")
                      : t("Surcharge Applies")}
                    {modelAccessories["27"]
                      ? modelAccessories["27"]["59"]
                        ? GetPrice(
                            modelAccessories["27"]["59"]["Price"],
                            pageLanguage,
                            t("TOMANS"),
                            isTabletOrMobile
                          )
                        : null
                      : null}
                  </p>
                </label>
              </div>
            </div>

            <div
              className={
                step9ADrapery === "None"
                  ? "card_body card_body_radio card_body_have_hardware card_body_have_hardware_new"
                  : "noDisplay"
              }
            >
              <div className="box100">
                <p className="step_selection_title step_selection_title_new">{t("step8A_haveHardware_title")}</p>
              </div>
              <div className="box-step9a">
              <div className="box50 radio_style">
                <div className="same_row_selection_title">{t("Drapery Hardware")}</div>
              </div>
              <div className="box50 radio_style">
                <div className="select_container">
                  <Select
                    className="select"
                    placeholder={t("Please Select")}
                    portal={document.body}
                    dropdownPosition="bottom"
                    dropdownHandle={false}
                    dropdownGap={0}
                    values={selectedDrapery}
                    onDropdownOpen={() => {
                      let temp1 = window.scrollY;
                      window.scrollTo(window.scrollX, window.scrollY + 1);
                      setTimeout(() => {
                        let temp2 = window.scrollY;
                        if (temp2 === temp1) window.scrollTo(window.scrollX, window.scrollY - 1);
                      }, 100);
                    }}
                    dropdownRenderer={({ props, state, methods }) => (
                      <CustomDropdown props={props} state={state} methods={methods} />
                    )}
                    contentRenderer={({ props, state, methods }) => (
                      <CustomControl props={props} state={state} methods={methods} />
                    )}
                    onChange={(selected) => {
                      if (selected.length && !pageLoad && !rodsLoad && !rodsLoad2) {
                        setCart("hardwareDrapery", selected[0].value);
                        setDeps("", "8A,8A1,8A2,85", 1);
                        setSelectedDrapery(selected);
                        let tempExtended = extendedTitle;
                        if (!tempExtended["8A"] || !tempExtended["8A"].length) {
                          tempExtended["8A"] = [t("None")];
                        }
                        tempExtended["8A"][1] = (
                          <li key="1" className="step_title_extended_list_item">
                            <span className="step_title_extended_list_item_title">
                              {t("Drapery Hardware")}
                            </span>
                            <span className="step_title_extended_list_item_text">
                              {pageLanguage === "fa" ? selected[0].label : selected[0].value}
                            </span>
                          </li>
                        );
                        setExtendedTitle(tempExtended);
                      }
                    }}
                   options={sheerDraperyOptions}
                  />
                </div>
              </div>
              </div>
            </div>
          </div>
          <NextStep currentStep="8A" eventKey="8B">
            {t("NEXT STEP")}
          </NextStep>
        </Card.Body>
      </Accordion.Collapse>
    </Card>
  );
}
